import { Component } from 'react';
import { Icon, IconName, ListItem } from '@optimus-web/core';

interface Props {
    passportScanner: $TSFixMe | $TSFixMe; // TODO: pt.instanceOf(IntegrationRedirect)
    onClick?: $TSFixMeFunction;
}

export default class PassportScannerLink extends Component<Props> {
    // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
    handleClick = () => this.props.onClick(this.props.passportScanner.id, this.props.passportScanner.url);

    render() {
        return (
            <ListItem
                primaryText={this.props.passportScanner.name}
                leftIcon={<Icon value={IconName.Scanner} />}
                onClick={this.handleClick}
            />
        );
    }
}
